export default __webpack_public_path__ + "media/images/qr/large_business_line-6aaeefe442b650c274ecec5059eefe14.png";